var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 3.75C21.1569 3.75 22.5 5.09315 22.5 6.75V17.25C22.5 18.9069 21.1569 20.25 19.5 20.25H4.5C2.84315 20.25 1.5 18.9069 1.5 17.25V6.75C1.5 5.09315 2.84315 3.75 4.5 3.75H19.5ZM13.5723 14.1631C12.6081 14.7564 11.3919 14.7564 10.4277 14.1631L3 9.5918V17.25C3 18.0784 3.67157 18.75 4.5 18.75H19.5C20.3284 18.75 21 18.0784 21 17.25V9.5918L13.5723 14.1631ZM4.5 5.25C3.67157 5.25 3 5.92157 3 6.75V6.99316L3.0127 7.18555C3.07039 7.63095 3.32559 8.03157 3.71387 8.27051L11.2139 12.8857C11.6959 13.1824 12.3041 13.1824 12.7861 12.8857L20.2861 8.27051C20.6744 8.03157 20.9296 7.63095 20.9873 7.18555L21 6.99316V6.75C21 5.92157 20.3284 5.25 19.5 5.25H4.5Z",
    fill: "#0F172A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.635199825371e45834bd6542e0eca209.svg";
export { ForwardRef as ReactComponent };